<template>
    <div>
        <b-form
                class="d-flex"
        >
            <b-form-input
                    type="search"
                    placeholder="Rechercher par prénom ou nom ..."
                    class="mb-2"
                    v-model="form.search"
            />
            <template v-if="multiple">
                <b-btn
                        v-if="!allSelected"
                        variant="link"
                        size="sm"
                        @click="all()"
                >
                    <i class="fas fa-plus"/> Tous
                </b-btn>
                <b-btn
                        v-else
                        variant="link"
                        size="sm"
                        @click="none()"
                >
                    <i class="fas fa-minus"/> Aucun
                </b-btn>
            </template>
        </b-form>
        <div class="mt-1">
            <user-detail
                    v-for="(user, index) of filtered"
                    :user="user"
                    :key="`user-add-${index}`"
                    :multiple="multiple"
                    :is-selected="isSelected(user)"
                    @click="change($event)"
            />
            <b-alert
                    class="mt-2"
                    :show="filtered.length === 0"
            >
                Aucun salarié ne correspond à votre recherche
            </b-alert>
        </div>
    </div>
</template>
<script>
    import UserDetail from "./Detail";

    export default {
        name: 'user-add',
        components: {UserDetail},
        props: {
            users: Array,
            multiple: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            selected: [],
            form: {
                search: ''
            }
        }),
        methods: {
            change(user) {
                if (!this.isSelected(user))
                    this.selected.push(user)
                else
                    this.selected = this.selected.filter((u) => {
                        return u.id !== user.id
                    })
            },
            isSelected(user) {
                return this.selected.filter((u) => {
                    return u.id === user.id
                }).length > 0
            },
            all() {
                this.selected = this.users
            },
            none(){
                this.selected = []
            }
        },
        computed: {
            allSelected() {
                return this.selected.length === this.users.length
            },
            filtered() {
                if (this.form.search === '') return this.users.slice(0, 9)
                const validator = new RegExp(this.form.search, 'i')
                return this.users.filter(user => {
                    return validator.test(this.$store.getters['base/account/getFullName'](user))
                })
            }
        },
        watch: {
            selected() {
                this.$emit('change', this.selected)
            }
        }
    }
</script>
